// @ts-check
import angular from 'angular'
import '../../shared/angular-style.css'
import Debug from 'debug'
const debug = Debug('app:resume:index')

import resumeTemplate from './resume.html'
import resumeController from './resume.ctrl'
import workerMenu from './menu.html'

export default angular.module('resume', ['ui.router'])
  .filter('shiftCalc', () => {
    return (shifts) => {
      let duration
      switch (true) {
        case (shifts < 5) :
          duration = 'a few shifts'
          break
        case (shifts >= 400):
          duration = '2 years'
          break
        case (shifts >= 230):
          duration = '1 year'
          break
        case (shifts >= 100):
          duration = '6 months'
          break
        case (shifts >= 50):
          duration = '3 months'
          break
        case (shifts >= 20):
          duration = '1 month'
          break
        default:
          duration = 'a few shifts'
      }
      return duration
    }
  })
  .config(function ($stateProvider) {
    'ngInject'

    $stateProvider.state('app.resume', {
      url: '/resume/:id',
      resolve: {
        worker: (Users, $mdDialog, $stateParams) => {
          'ngInject'

          return Users.getProfile($stateParams.id)
        },
        application: (Users, $stateParams) => {
          'ngInject'

          return Users.fetchApplication($stateParams.id)
        },
        inModal: () => { return false }
      },
      views: {
        content: {
          controller: resumeController,
          controllerAs: 'w',
          template: resumeTemplate
        },
        menu: {
          template: workerMenu
        }
      }
    })
  })
